import React from "react";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import Repeater from "Components/repeater/Repeater";
import { formatServerErrors } from "Utils/serverFormats";
import withFormState from "Components/withFormState";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import isEmail from "validator/lib/isEmail";

import cx from "classnames";
import s from "./destinationsModal.scss";

const formInitialState = {
  destinations: []
};

class DestinationsModal extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.props.setFormFieldValue({ destinations: this.props.destinations });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.destinations.length !== this.props.destinations.length) {
      this.props.setFormFieldValue({ destinations: nextProps.destinations });
    }
  }

  submitForm(e) {
    e.preventDefault();
    this.props.setFormLoading();
    this.props
      .updateAliasEmail(this.props.aliasEmailcode, this.props.formData)
      .then(() => {
        this.props.unsetFormLoading();
        this.props.setFormErrors({})
      })
      .catch(response => {
        formatServerErrors(response).then(errors => {
          this.props.setFormErrors(errors);
          this.props.unsetFormLoading();
        });
      });
  }

  close() {
    this.props.handleClose()
    this.props.setFormErrors({})
  }

  render() {
    const {
      opened,
      handleClose,
      formData,
      setFormFieldValue,
      formErrors,
      isFormLoading
    } = this.props;

    return (
      <Modal
        title={t("modal.add.destination.title")}
        opened={opened}
        closeModal={this.close}
        withForm
      >
        <form className={s.form} method="post" onSubmit={this.submitForm.bind(this)}>
          <Repeater
            className={s.repeater}
            labelInput={t("input.label.add.destination")}
            label={t("listTable.header.title.destinations")}
            name="destinations"
            onChange={setFormFieldValue}
            values={formData.destinations}
            errors={formErrors.destinations}
            placeholder="myotheremail@domain.com"
            validateNewValue={newVal => {
              if (!isEmail(newVal)) {
                alert(`${newVal} is not a valid email address`);
                return false;
              }
              return true;
            }}
          />
          <div className={s.footerBtn}>
            <Button color="text" onClick={this.close}>
              button.cancel
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </form>
      </Modal>
    );
  }
}

export default withFormState(DestinationsModal, formInitialState);
